import {
  LinkedUsers,
  BlockUserModal,
  MarkFraudModal,
  ResetPinModal,
} from '../../../popups';
import { UserCarts } from '../../../popups/GetUserCarts/GetUserCarts';
import React from 'react';
import { UserBMoneyTxns } from '../../../popups/UserBMoneyTxns/UserBMoneyTxns';
import ChatSummary from '../../../popups/ChatSummary/ChatSummary';
import { MessageSquareText } from 'lucide-react';
import { UnmarkFraudModal } from '../../../popups/UnmarkFraudModal';

export const getBlinkitActionsList = [
  {
    slug: 'get_chat_history',
    showScrollBar: true,
  },
  {
    title: 'Get B-Money Transactions',
    type: 'details',
    value: UserBMoneyTxns,
    heading: (
      <div className='tw-flex tw-items-center tw-gap-2 tw-text-[2rem] tw-font-medium tw-text-zinc-700 tw-ml-4'>
        B-Money Transactions
      </div>
    ),
    slug: 'get_bmoney_transactions',
    minHeight: '80vh',
    modalType: 'huge',
    showScrollBar: true,
  },
  {
    title: 'Get Customer Carts',
    type: 'details',
    value: UserCarts,
    heading: 'Get Customer Carts',
    slug: 'get_all_carts',
    minHeight: '80vh',
    paddingTop: '0',
    showScrollBar: false,
    titleStyle: {
      fontSize: '17px',
      fontWeight: '800',
    },
  },
  {
    title: 'Block/Unblock User',
    type: 'details',
    value: BlockUserModal,
    heading: 'Block/Unblock User',
    modalType: 'medium',
    slug: 'block_unblock_user',
    minHeight: '15vh',
    maxHeight: '80vh',
    showScrollBar: true,
  },
  {
    title: 'Mark Customer Fraud',
    type: 'details',
    value: MarkFraudModal,
    heading: '🚨 Mark customer fraud',
    modalType: 'large',
    slug: 'mark_order_fraud',
    minHeight: '15vh',
    maxHeight: '80vh',
    showScrollBar: true,
  },
  {
    title: 'Linked customer accounts',
    slug: 'get_linked_users',
    type: 'details',
    value: LinkedUsers,
    heading: 'Linked customer accounts',
    modalType: 'huge',
    minHeight: '70vh',
    showScrollBar: true,
    containerStyles: {
      height: '1px',
    },
  },
  {
    title: 'Chat Summary',
    type: 'details',
    value: ChatSummary,
    heading: (
      <div className='tw-flex tw-items-center tw-gap-2 tw-text-[2rem] tw-font-medium tw-text-zinc-700'>
        <MessageSquareText className='tw-mt-1' />
        Chat Summary
      </div>
    ),
    slug: 'get_chat_summary',
    minHeight: '80vh',
    showScrollBar: true,
  },
  {
    title: 'Reset sensitive mode settings',
    type: 'details',
    value: ResetPinModal,
    heading: '🔄 Reset sensitive mode settings',
    modalType: 'medium',
    slug: 'reset_restricted_mode',
    minHeight: '15vh',
    maxHeight: '80vh',
    showScrollBar: true,
  },
  {
    title: 'Unmark Customer Fraud',
    type: 'details',
    value: UnmarkFraudModal,
    heading: 'Unmark Customer Fraud',
    modalType: 'large',
    slug: 'unmark_order_fraud',
    minHeight: '15vh',
    maxHeight: '80vh',
    showScrollBar: true,
  },
];
